var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"label":_vm.$t('address.searchAddress'),"append-icon":"mdi-magnify","loading":_vm.loading,"clearable":"","rounded":"","solo":""},on:{"click:append":_vm.getLocationSearched,"click:clear":_vm.searchCleared},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})
}
var staticRenderFns = []

export { render, staticRenderFns }